import { getContentInnerPage } from "../api/getContentInnerPage.js";

export default {
  namespaced: true,

  state: {
    list: {},
    renderMap: {},
    calendarList: {},
    //Костыль для исключения дублирования новых комментариев
    newCommentsId: [],
  },

  actions: {
    //Получаем данные внутренней страницы поста
    async loadInfonoiseData({ getters, state, commit }) {
      try {
        const idString = getters.getContentIdString;
        if (!idString) return; 
        const data = await getContentInnerPage(idString);
        commit('updatePostsData', data);
      } catch (error) {
        console.error(`Ошибка при получении контеной части для Ифошума:`, error);
      }
    },
    //Добавляем посты в словарь и строим карту их отображения
    addItemsToList({ state, commit }, { infonoise, isNew }){
      commit('addItems', { infonoise, isNew });
      commit('sortRenderMap');
    },
    //Обновить мини сигналы
    updateMiniSignals({ commit }, data){
      commit('REFRESH_MINI_SIGNALS', data);
    },
  },

  mutations: {
    //Добавляем посты в словарь и строим карту их отображения
    addItems(state, { infonoise, isNew }) {
      Object.entries(infonoise).forEach(([item, data]) => {
        // Инициализируем renderMap и calendarList, если их нет
        if (!state.renderMap.hasOwnProperty(item)) state.renderMap[item] = [];
        if (!state.calendarList[item]) state.calendarList[item] = [];
        // Функция для обработки постов
        const processPosts = (posts) => {
          posts.forEach((post) => {
            // Проверка и добавление в renderMap
            if (!state.renderMap[item].includes(post.id)) {
              state.renderMap[item].unshift(post.id)
            }
            // Добавление в state.list
            if(!state.list[post.id]?.is_ready_inner_page) {
              if(isNew) post.is_new = isNew;
              state.list[post.id] = post;
            }
          });
        };
        // Обрабатываем обычные посты
        if (data.posts?.length) processPosts(data.posts);
        if (!state.calendarList[item]) {
          state.calendarList[item] = data.calendar;
        } else {
          for (const key in data.calendar) {
            if (!(key in state.calendarList[item])) {
              state.calendarList[item][key] = data.calendar[key];
            }
          }
        }
      });
    },
    //Сортируем карту отображения
    sortRenderMap(state) {
      Object.keys(state.renderMap).forEach(item => {
        state.renderMap[item] = state.renderMap[item].sort((a, b) => {
          const postA = state.list[a];
          const postB = state.list[b];
          const dateA = new Date(postA?.publication_date).getTime();
          const dateB = new Date(postB?.publication_date).getTime();
          return dateB - dateA;
        });
      });
    },
    toAddNewPostWithoutRender(state, post){
      const id = post.id;
      state.list[id] = post;
      state.list[id]['model_name'] = state.list[id]['model_name'].toLowerCase();
      if(post['content']) state.list[id]['is_ready_inner_page'] = true;
    },
    //Добавляем полученные данные к объектам в списке
    updatePostsData(state, data){
      data.forEach((item) => {
        const id = item.id;
        const post = state.list[id];
        state.list[id] = {...item, ...post}
        state.list[id]['content'] = item['content'];
        state.list[id]['is_ready_inner_page'] = true;
      });
    },
    //Очистить список рендера
    clearData(state){
      state.renderMap = {};
    },
    //Обновить счетчик до начала собтытия в календаре
    updateEventCountdown(state, { keyDate, index }) {
      if (state.calendarList[keyDate] && state.calendarList[keyDate][index]) {
        const updatedList = [...state.calendarList[keyDate]];
        updatedList[index] = {
          ...updatedList[index],
          countdown_main_page: false
        };
        state.calendarList[keyDate] = updatedList;
      }
    },
    //Обновить состояние реакций
    toChangeReactions(state, {object_id, reactions}){
      state.list[object_id].reactions.is_mine = reactions.is_mine;
      state.list[object_id].reactions.reactions_values = reactions.reactions_values;
    },
    //Обновить счетчик новых комментариев
    toUpdateNewCommentsCounter(state, {id}){
      if(!state.list[id]) return;
      state.list[id].init_comments_count = state.list[id].comments_count;
    },
    //Обновить последний комментарий поста
    toChangeLastComment(state, {comment}){
      if(!state.list[comment.object_pk]) return;
      state.list[comment.object_pk].last_comment = comment;
    },
    //Увеличить счетчик комментариев
    toIncreaseCommentCount(state, { id, count }){
      if(!state.list[id]) return;
      state.list[id].comments_count = count;
      if(state.list[id].comments_count < state.list[id].init_comments_count){
        state.list[id].init_comments_count = count
      }
    },
    //Увеличить счетчик начальных комментариев
    toIncreaseInitCommentCount(state, { id }){
      state.list[id].init_comments_count++;
    },
    //Зарегистрировать ID пришедшего коммента
    toRegisterIdNewComment(state, { id }){
      state.newCommentsId.push(id);
    },
    //Обновить мини сигналы
    REFRESH_MINI_SIGNALS(state, data){
      data.forEach(item => {
        state.list[item.id].coin_prices = item.coins;
      });
    },
    //Обновить статус isNew
    toUpdateNewStatus(state, id){
      state.list[id].is_new = false;
    }
  },

  getters:{
    getContentIdString(state) {
      const idArray = [];
      for (const item in state.list) {
        if (!state.list[parseInt(item)].is_ready_inner_page) {
          idArray.push(parseInt(item));
        }
      }
      return idArray.length > 0 ? idArray.join(',') : null;
    }
  },
}